export default __webpack_public_path__ + "static/media/iconTask.571a22a9.svg";